const DATABASE_NAME = "better-table-pending-upload";
const STORE_NAME = "uploads";
const FRIDGE_IMAGE_KEY = "fridge-images";

function openDatabase() {
  return new Promise<IDBDatabase>((resolve, reject) => {
    const request = indexedDB.open(DATABASE_NAME, 1);
    request.onupgradeneeded = () => {
      const database = request.result;
      if (!database.objectStoreNames.contains(STORE_NAME)) {
        database.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error("임시 이미지 저장소를 열 수 없습니다."));
  });
}

function waitForTransaction(transaction: IDBTransaction) {
  return new Promise<void>((resolve, reject) => {
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error ?? new Error("임시 이미지 처리에 실패했습니다."));
    transaction.onabort = () => reject(transaction.error ?? new Error("임시 이미지 처리가 중단되었습니다."));
  });
}

export async function savePendingFridgeImages(files: File[]) {
  const database = await openDatabase();
  try {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).put(files, FRIDGE_IMAGE_KEY);
    await waitForTransaction(transaction);
  } finally {
    database.close();
  }
}

export async function loadPendingFridgeImages() {
  const database = await openDatabase();
  try {
    const transaction = database.transaction(STORE_NAME, "readonly");
    const request = transaction.objectStore(STORE_NAME).get(FRIDGE_IMAGE_KEY);
    const files = await new Promise<File[]>((resolve, reject) => {
      request.onsuccess = () => resolve(Array.isArray(request.result) ? request.result as File[] : []);
      request.onerror = () => reject(request.error ?? new Error("임시 이미지를 불러오지 못했습니다."));
    });
    await waitForTransaction(transaction);
    return files;
  } finally {
    database.close();
  }
}

export async function clearPendingFridgeImages() {
  const database = await openDatabase();
  try {
    const transaction = database.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).delete(FRIDGE_IMAGE_KEY);
    await waitForTransaction(transaction);
  } finally {
    database.close();
  }
}
